import { Component, Type, Input, ViewChild, ChangeDetectorRef } from "@angular/core";
import { RelatedFormComponent } from "../related-form/related-form.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { PeopleInfo } from "projects/sepidz-web-framework/src/lib/models/peopleInfo.model";
import { takeUntil } from "rxjs/operators";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "related-list",
  templateUrl: "./related-list.component.html",
  styleUrls: ["./related-list.component.scss"],
})
export class RelatedListComponent extends BaseListComponent {
  PeopleInfoRelateds: form_control[];
  @ViewChild("grid") public grid: KGridComponent;
  @Input() _columns: form_control[];
  @Input() isTabActive: boolean = false;
  private innerModel: PeopleInfo = <PeopleInfo>{};
  @Input()
  public set model(value: PeopleInfo) {
    if (this.innerModel !== value) {
      this.innerModel = value;
      if (this.grid) {
        this.grid.refreshData();
        this.grid.setDefaultColumnInfo();
      }
    }
  }
  public get model(): PeopleInfo {
    return this.innerModel;
  }
  inputEditorform: Type<RelatedFormComponent> = RelatedFormComponent;
  constructor(protected cd: ChangeDetectorRef, protected selectorService: SelectorService) {
    super();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.inputEditorform = undefined;
    this.PeopleInfoRelateds = undefined;
    this.grid = undefined;
    this._columns = undefined;
    this.innerModel = undefined;
  }
  ngOnInit() {
    super.ngOnInit();
    this.label = this.translate("ClientApp.GNR.PeopleInfo.Related.RelatedPersons");
    if (!this.model.PeopleInfoRelateds) this.model.PeopleInfoRelateds = [];
    else {
      let uid: number = 0;
      this.model.PeopleInfoRelateds.forEach((x) => {
        uid++;
        x["UId"] = uid;
      });
    }
    this.PeopleInfoRelateds = this.getDetailControlModels("PeopleInfoRelateds");
    setTimeout(() => {
      if (this.grid) {
        this.grid.columns = this.PeopleInfoRelateds;
        this.grid.refreshData();
        this.grid.setDefaultColumnInfo();
      }
    }, 200);

    this.cd.markForCheck();
  }
  public addHandler(event) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: null,
          apiName: this.apiName,
          areaName: this.areaName,
          Columns: this.getDetailControlModels("PeopleInfoRelateds"),
          label: this.translate("ClientApp.GNR.PeopleInfo.Related.RelatedPersons"),
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          model["UId"] = this.model.PeopleInfoRelateds.length + 1;
          model.State = RowState.New;
          this.model.PeopleInfoRelateds.push(model);
        }
        this.cd.markForCheck();
        if (this.grid) {
          this.grid.refreshData();
          this.grid.setDefaultColumnInfo();
        }
        this.selectorService.onSubmited.next(true);
      });
  }

  public editHandler(event) {
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: event,
          areaName: this.areaName,
          apiName: this.apiName,
          Columns: this.getDetailControlModels("PeopleInfoRelateds"),
          label: this.translate("ClientApp.GNR.PeopleInfo.Related.RelatedPersons"),
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        if (model) {
          this.model.PeopleInfoRelateds.forEach((x) => {
            if (x["UId"] === model["UId"]) {
              if (model.State !== RowState.New) model.State = RowState.Modify;
              Object.assign(x, model);
            }
          });
        }
        if (this.grid) this.grid.refreshData();
      });
  }

  public removeHandler(dataItem) {
    this.sts.showDialog(`${this.translate("ClientApp.GNR.PeopleInfo.Related.SureDeleteInformation")}`, "", DialogType.confirm, () => {
      this.model.PeopleInfoRelateds.forEach((x) => {
        if (x["UId"] === dataItem["UId"]) {
          if (x.State == RowState.New) x.State = RowState.Detached;
          else x.State = RowState.Delete;
        }
      });
      if (this.grid) this.grid.refreshData();
    });
  }
  getDetailControlModels(keyName: string) {
    if (this._columns?.find((x) => x.name === keyName)?.DetailControlModels) {
      var col = this._columns.find((x) => x.name === keyName).DetailControlModels[keyName];
      return col.sort((a, b) => a.order - b.order);
    }
    return [];
  }
}
